import { useRef, useEffect, useState } from 'react';
import { products } from '../../../mocks/homeData';

export default function ProductSection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const scrollToPurchase = () => {
    const el = document.querySelector('#purchase');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="products" className="bg-[#FAFAF8] py-24 px-6" ref={sectionRef}>
      <div className="max-w-7xl mx-auto">
        <div className={`text-center mb-16 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <p className="text-[#8B7355] text-xs font-medium tracking-[0.3em] uppercase mb-3">Our Products</p>
          <h2 className="text-[#2C2825] text-4xl lg:text-5xl font-light mb-4">
            프리미엄 지올라이트 제품
          </h2>
          <p className="text-[#6B5F52] text-base max-w-2xl mx-auto leading-relaxed">
            100% 천연 활성 제올라이트 클리놉틸로라이트 분말로, 독소와 중금속이 체내에 흡수되기 전에 중화합니다.<br />
            매일의 디톡스 습관으로 독소 축적을 예방하고, 더 건강한 삶을 지원합니다.
          </p>
          <div className="mt-6 flex items-center justify-center gap-8 flex-wrap">
            <div className="text-center">
              <p className="text-[#2C2825] text-2xl font-light">최대 90%</p>
              <p className="text-[#8B7355] text-xs tracking-widest uppercase mt-1">카드뮴 제거</p>
            </div>
            <div className="w-px h-8 bg-[#DDD5C8]"></div>
            <div className="text-center">
              <p className="text-[#2C2825] text-2xl font-light">최대 82%</p>
              <p className="text-[#8B7355] text-xs tracking-widest uppercase mt-1">수은 제거</p>
            </div>
            <div className="w-px h-8 bg-[#DDD5C8]"></div>
            <div className="text-center">
              <p className="text-[#2C2825] text-2xl font-light">최대 75%</p>
              <p className="text-[#8B7355] text-xs tracking-widest uppercase mt-1">비소 제거</p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {products.map((product, i) => (
            <div
              key={product.id}
              id={`product-${product.id}`}
              className={`bg-white rounded-2xl overflow-hidden border border-[#F0EBE3] hover:border-[#C4A882] transition-all duration-500 cursor-pointer group ${
                visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
              }`}
              style={{ transitionDelay: `${i * 150}ms` }}
            >
              <div className="relative w-full h-80 bg-[#FAFAF7] flex items-end justify-center px-4 pt-6 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="max-w-full object-contain group-hover:scale-105 transition-transform duration-700"
                  style={{ maxHeight: '268px', width: 'auto' }}
                />
                <span className="absolute top-4 left-4 bg-[#8B7355] text-white text-xs px-3 py-1 rounded-full font-medium">
                  {product.badge}
                </span>
              </div>
              <div className="p-6">
                <p className="text-[#8B7355] text-xs tracking-[0.2em] uppercase mb-1">{product.subtitle}</p>
                <h3 className="text-[#2C2825] text-xl font-medium mb-2">
                  {product.name}
                </h3>
                <p className="text-[#6B5F52] text-sm leading-relaxed mb-4">{product.description}</p>
                <ul className="space-y-1 mb-5">
                  {product.benefits.map((b) => (
                    <li key={b} className="flex items-center gap-2 text-xs text-[#6B5F52]">
                      <span className="w-1 h-1 rounded-full bg-[#8B7355] flex-shrink-0"></span>
                      {b}
                    </li>
                  ))}
                </ul>
                <div className="flex items-end justify-between pt-4 border-t border-[#F0EBE3]">
                  <div>
                    <p className="text-[#2C2825] text-2xl font-light">
                      ₩{product.price}
                    </p>
                    <p className="text-[#9B8E82] text-xs">{product.unit}</p>
                  </div>
                  <button
                    onClick={scrollToPurchase}
                    className="bg-[#2C2825] text-white text-sm px-5 py-2 rounded-full hover:bg-[#8B7355] transition-colors duration-300 cursor-pointer whitespace-nowrap">
                    구매하기
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
